import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { api } from "../services/api";
import CategoryForm from "./CategoryForm";
import "../style.css";

export default function Categories() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);

  async function load() {
    const res = await api.get("/categories");
    setItems(res.data.data || []);
  }

  useEffect(() => {
    load().catch(() => {});
  }, []);

  function startAdd() {
    setEdit(null);
    setOpen(true);
  }

  function startEdit(c) {
    setEdit(c);
    setOpen(true);
  }

  async function remove(id) {
    if (!window.confirm("Delete category?")) return;
    await api.delete(`/categories/${id}`);
    await load();
  }

  return (
    <Layout>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <h2>Categories</h2>
        <button className="btn btn-primary" onClick={startAdd}>+ New Category</button>
      </div>

      <div className="card" style={{ marginTop: 12 }}>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Slug</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {items.map((c) => (
              <tr key={c._id}>
                <td style={{ fontWeight: 900 }}>{c.name}</td>
                <td className="muted">{c.slug}</td>
                <td>{c.isActive ? <span className="badge">Active</span> : <span className="badge">Inactive</span>}</td>
                <td>
                  <div className="actions">
                    <button className="btn btn-ghost" onClick={() => startEdit(c)}>Edit</button>
                    <button className="btn btn-danger" onClick={() => remove(c._id)}>Delete</button>
                  </div>
                </td>
              </tr>
            ))}

            {!items.length ? (
              <tr>
                <td colSpan="4" className="muted">No categories yet.</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>

      {open ? (
        <div className="card" style={{ marginTop: 14, padding: 16 }}>
          <CategoryForm existing={edit} onDone={async () => { setOpen(false); await load(); }} />
        </div>
      ) : null}
    </Layout>
  );
}
